module.exports = __webpack_public_path__ + "static/media/reservations-01.93183806.png";